import { Button, Input, InputGroup, Select } from '@raskrask-dk/rr-components'
import { StyledComplexCodeInputGroup } from './styles'
import { ReactElement } from 'react'
import { ComplexCodeInputGroupProps } from './props'
import { Option } from '@raskrask-dk/rr-components/lib/Atoms/Select/props'

/**
 * Complex Code Input Group
 * Normally used in Gave Code validator.
 */
const ComplexCodeInputGroup = <
    Provider extends Option,
    CodeValue extends Option
>({
    providerListHandler,
    codeInputHandler,
    activationCodeInputHandler,
    codeValueListHandler,
    ctaHandler,
}: ComplexCodeInputGroupProps<Provider, CodeValue>): ReactElement => {
    const {
        providerLabel,
        onChangeProvider,
        providerOptions,
        defaultProvider,
    } = providerListHandler
    const {
        code,
        onChangeCode,
        helperText,
        isInputFieldDisabled,
        isError,
        placeholder,
        onBlur,
        dataCy,
    } = codeInputHandler
    const {
        isActivationCodeFieldShown,
        activationCodeDataCy,
        isActivationCodeErrorShown,
        onBlurActivationCode,
        onChangeActivationCode,
        activationCodePlaceHolder,
        isActivationFieldDisabled,
    } = activationCodeInputHandler
    const {
        isCodeValueSelectorShown,
        onChangeCodeValueOption,
        codeValueOptions,
        codeValuePlaceHolder,
        defaultCodeValue,
        selectedOption,
    } = codeValueListHandler
    const { isButtonDisabled, onClickButton, buttonText } = ctaHandler

    return (
        <>
            <StyledComplexCodeInputGroup>
                <Select
                    css={{ '@desktop': { maxW: 175 } }}
                    label={providerLabel}
                    onChange={onChangeProvider}
                    options={providerOptions}
                    defaultValue={defaultProvider}
                />
                <InputGroup
                    data-cy={dataCy}
                    error={isError}
                    onBlur={onBlur}
                    onChange={onChangeCode}
                    placeholder={placeholder}
                    type="text"
                    value={code}
                    helperText={helperText}
                    disabled={isInputFieldDisabled}
                    key={'complexinput1'}
                />
            </StyledComplexCodeInputGroup>
            {isActivationCodeFieldShown && (
                <Input
                    data-cy={activationCodeDataCy}
                    error={isActivationCodeErrorShown}
                    onBlur={onBlurActivationCode}
                    onChange={onChangeActivationCode}
                    placeholder={activationCodePlaceHolder}
                    disabled={isActivationFieldDisabled}
                />
            )}
            {isCodeValueSelectorShown && (
                <Select
                    onChange={(e) => onChangeCodeValueOption(e)}
                    options={codeValueOptions}
                    placeholder={
                        selectedOption === undefined ? codeValuePlaceHolder : ''
                    }
                    defaultValue={defaultCodeValue}
                />
            )}
            <Button onClick={onClickButton} disabled={isButtonDisabled}>
                {buttonText}
            </Button>
        </>
    )
}

export default ComplexCodeInputGroup
